import { FIFTEEN_MINUTES } from '@avanta/shared/constants/common';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { QUERY_KEYS } from 'constants/common';
import { ENTERPRISE_CONTRACT_STATUS } from 'constants/enterprise';
import { EnterprisesService } from 'services/enterprises';
import { useEnterpriseId } from 'stores/user';
import { type EnterpriseContract } from 'types/enterprises';

export const useFetchEnterpriseContracts = (): UseQueryResult<EnterpriseContract[]> => {
  const enterpriseId = useEnterpriseId();
  return useQuery({
    queryKey: [QUERY_KEYS.FETCH_ENTERPRISE_CONTRACTS, enterpriseId],
    queryFn: () => EnterprisesService.getEnterpriseContracts(enterpriseId),
    select: response =>
      response.data.filter(contract => contract.status === ENTERPRISE_CONTRACT_STATUS.ACTIVE),
    enabled: !!enterpriseId,
    staleTime: FIFTEEN_MINUTES,
  });
};
